var map = {
	"./403.svg": 45295,
	"./account.svg": 49062,
	"./arrow-down.svg": 37794,
	"./collect.svg": 12758,
	"./delete.svg": 98582,
	"./distribut.svg": 88196,
	"./down-arrow.svg": 31651,
	"./draft.svg": 85059,
	"./edit.svg": 4691,
	"./errorFileIcon.svg": 28248,
	"./facebook-active.svg": 34136,
	"./facebook.svg": 66343,
	"./google-active-no-border.svg": 70221,
	"./google-active-old.svg": 67626,
	"./google-active.svg": 54042,
	"./google.svg": 94510,
	"./icon-zhekou.svg": 57557,
	"./kefu.svg": 7187,
	"./link-expired.svg": 37494,
	"./more.svg": 57059,
	"./move-folder-icon.svg": 59346,
	"./pan.svg": 82277,
	"./percent80-en.svg": 60334,
	"./percent80.svg": 79557,
	"./refresh.svg": 9396,
	"./share.svg": 74485,
	"./snapchat-active.svg": 10929,
	"./snapchat.svg": 47287,
	"./sucaibi.svg": 94547,
	"./tiktok-active.svg": 63053,
	"./tiktok.svg": 24934,
	"./tmp.svg": 2130,
	"./twitter-active-old.svg": 98267,
	"./twitter-active.svg": 5760,
	"./twitter-old.svg": 27044,
	"./twitter.svg": 14127,
	"./un-classification.svg": 75437,
	"./upload.svg": 69073,
	"./works.svg": 10538,
	"src/assets/svg/403.svg": 45295,
	"src/assets/svg/account.svg": 49062,
	"src/assets/svg/arrow-down.svg": 37794,
	"src/assets/svg/collect.svg": 12758,
	"src/assets/svg/delete.svg": 98582,
	"src/assets/svg/distribut.svg": 88196,
	"src/assets/svg/down-arrow.svg": 31651,
	"src/assets/svg/draft.svg": 85059,
	"src/assets/svg/edit.svg": 4691,
	"src/assets/svg/errorFileIcon.svg": 28248,
	"src/assets/svg/facebook-active.svg": 34136,
	"src/assets/svg/facebook.svg": 66343,
	"src/assets/svg/google-active-no-border.svg": 70221,
	"src/assets/svg/google-active-old.svg": 67626,
	"src/assets/svg/google-active.svg": 54042,
	"src/assets/svg/google.svg": 94510,
	"src/assets/svg/icon-zhekou.svg": 57557,
	"src/assets/svg/kefu.svg": 7187,
	"src/assets/svg/link-expired.svg": 37494,
	"src/assets/svg/more.svg": 57059,
	"src/assets/svg/move-folder-icon.svg": 59346,
	"src/assets/svg/pan.svg": 82277,
	"src/assets/svg/percent80-en.svg": 60334,
	"src/assets/svg/percent80.svg": 79557,
	"src/assets/svg/refresh.svg": 9396,
	"src/assets/svg/share.svg": 74485,
	"src/assets/svg/snapchat-active.svg": 10929,
	"src/assets/svg/snapchat.svg": 47287,
	"src/assets/svg/sucaibi.svg": 94547,
	"src/assets/svg/tiktok-active.svg": 63053,
	"src/assets/svg/tiktok.svg": 24934,
	"src/assets/svg/tmp.svg": 2130,
	"src/assets/svg/twitter-active-old.svg": 98267,
	"src/assets/svg/twitter-active.svg": 5760,
	"src/assets/svg/twitter-old.svg": 27044,
	"src/assets/svg/twitter.svg": 14127,
	"src/assets/svg/un-classification.svg": 75437,
	"src/assets/svg/upload.svg": 69073,
	"src/assets/svg/works.svg": 10538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78131;